/**
 * Layout: Hero - Contact
 * Slug: hero_contact
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hero_contact-layout');

	layouts.forEach((layout) => {
		
	});
});
